export default {
  id: 12,
  title: 'Target #12 - Wiggly Moustache',
  url: 'https://cssbattle.dev/play/12',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#f5d6b4}a{position:fixed;border-radius:50%}a[a],a[b],a[c]{top:100;width:60;height:60;border:20px solid #d86f45;clip:rect(50px,auto,auto,auto)}a[a]{left:70}a[b]{left:150;transform:rotate(180deg)}a[c]{right:70}a[d]{top:140;left:70;width:20;height:20;background:#d86f45;box-shadow:240px 0 #d86f45}</style>',
}
